export default __webpack_public_path__ + "static/media/IndiaPolls-Hindi-Logo-without-BG.5a929563.png";